import React, { useRef, useState } from 'react';
import {
	ClickAwayListener,
	Grow,
	MenuItem,
	MenuList,
	Paper,
	Popper,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import './style.scss';

/**
 * Menu "3 points" d'une carte partenaire — base neuve.
 *
 * Le Popper est monté dans un portail (pas de disablePortal) : la tuile
 * "en configuration" est en overflow: hidden, un menu interne y serait rogné.
 * Il porte la classe `card-menu__popper` pour que les cartes qui écoutent le
 * clic extérieur puissent l'ignorer.
 *
 * @param {Array} props.items { key, label, icon, danger, onClick }
 * @param {String} props.iconClassName classe de l'icône déclencheur (style selon la carte)
 */
const CardMenu = ({ items = [], iconClassName = 'card-active__icon' }) => {
	const anchorRef = useRef(null);
	const [open, setOpen] = useState(false);

	if (!items.length) return null;

	const handleClickAway = event => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) return;
		setOpen(false);
	};

	const handleSelect = (event, item) => {
		event.stopPropagation();
		setOpen(false);
		if (item.onClick) item.onClick(event);
	};

	return (
		<div className="card-menu">
			<div
				className={iconClassName}
				ref={anchorRef}
				onClick={event => {
					event.stopPropagation();
					setOpen(prev => !prev);
				}}>
				<MoreVertIcon />
			</div>

			<Popper
				className="card-menu__popper"
				open={open}
				anchorEl={anchorRef.current}
				transition
				placement="bottom-end">
				{({ TransitionProps }) => (
					<Grow {...TransitionProps}>
						<Paper>
							<ClickAwayListener onClickAway={handleClickAway}>
								<MenuList>
									{items.map(item => (
										<MenuItem
											key={item.key}
											className={`card-menu__item${
												item.danger ? ' card-menu__item--danger' : ''
											}`}
											onClick={event => handleSelect(event, item)}>
											{item.icon ? <item.icon /> : null}
											{item.label}
										</MenuItem>
									))}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</div>
	);
};

export default CardMenu;
